import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { WorkloadKpiMemberPageEntity } from '../../../domain/entities/workload-kpi-member-page.entity';
import { TeamWorkloadRepository } from '../../../infrastructure/repositories/team-workload.repository';
import { GetWorkloadKpiMembersQuery } from './get-workload-kpi-members.query';

@Injectable({ providedIn: 'root' })
export class GetWorkloadKpiMembersUseCase {
  private readonly _repository = inject(TeamWorkloadRepository);

  public execute(query: GetWorkloadKpiMembersQuery): Observable<WorkloadKpiMemberPageEntity> {
    return this._repository.getKpiMembers(query.kpi, query.page, query.size);
  }
}
